import { URL_USER_ORGANIZATION_TEAM } from '@tools/routes/routes';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import TeamView from './views/TeamView.vue';

export const initProfileOrganization = () => {
  if (!document.getElementById('user-profile-team')) {
    return;
  }

  const pinia = createPinia();
  const app = createApp(TeamView);

  app.config.globalProperties.$companyName = window.COMPANY_NAME;

  const routes = [
    {
      path: URL_USER_ORGANIZATION_TEAM,
      name: 'TeamView',
      component: TeamView,
    },
  ];

  const router = createRouter({
    routes,
    history: createWebHistory(),
  });

  app.use(router);
  app.use(pinia);
  app.mount('#user-profile-team');
};
